// 存放营销系统常量
const MARKETING_CONSTANTS = {
	MARKETING_TERMINAL_TYPE: {
		4: {
			value: 4,
			desc: 'APP'
		},
		5: {
			value: 5,
			desc: '微信小程序'
		},
		6: {
			value: 6,
			desc: '支付宝小程序'
		},
    7: {
			value: 7,
			desc: '抖音小程序'
		},
	},
	MARKETING_USED: {
		0: {
			value: 0,
			desc: '未使用'
		},
		1: {
			value: 1,
			desc: '已核销'
		},
		2: {
			value: 2,
			desc: '已锁定'
		}
	},
}

export default MARKETING_CONSTANTS
